import { Copy } from '@sparemin/blockhead';
import React from 'react';
import { notifySuccess } from 'components/notification/showNotification';
import { useTranscriptId } from 'pages/TranscriptEditorPage/state';
import { useGetFirstSuggestedShowNotes } from 'pages/TranscriptEditorPage/state/useGetTranscriptNoteSuggestions';
import { copyToClipboard } from 'utils/clipboard';

import * as S from './styles';
import useTrackCopyShowNotes from './useTrackCopyShowNotes';

const ShareAutogeneratedSummary: React.FunctionComponent = () => {
  const { data: transcriptId } = useTranscriptId();
  const { data: showNotes = '' } = useGetFirstSuggestedShowNotes(transcriptId);
  const { trackCopyShowNotes } = useTrackCopyShowNotes();

  const handleCopyToClipboard = React.useCallback(() => {
    copyToClipboard(showNotes);
    notifySuccess({
      heading: 'Show Notes copied to clipboard!',
      toastId: 'suggested-show-notes-copied',
    });
    trackCopyShowNotes();
  }, [showNotes, trackCopyShowNotes]);

  if (!showNotes) {
    return null;
  }

  return (
    <S.Container>
      <S.Header>
        <S.Title level={4}>Show Notes</S.Title>
        <S.Subtitle variant="legal">
          We’ve auto-generated an episode summary for you.
        </S.Subtitle>
      </S.Header>
      <S.SummaryContainer>
        <S.Overlay onClick={handleCopyToClipboard}>
          <Copy /> <S.CopyLabel variant="button">COPY TO CLIPBOARD</S.CopyLabel>
        </S.Overlay>
        <S.SummaryText variant="p">
          {showNotes.split('\n').map((text, index) => (
            <S.Paragraph key={index}>{text}</S.Paragraph>
          ))}
        </S.SummaryText>
      </S.SummaryContainer>
    </S.Container>
  );
};

export default ShareAutogeneratedSummary;
